<template>
    <FilterExpandCollapse label="Specialties" :expand="false" v-show="show">
      <!-- Need to put a key on the ShowMore component so that it will redraw completely when the data changes -->
      <!-- If we don't do this we will get DOM errors when the slot gets re-rendered                           -->
      <FilterShowMore :threshold="10" :topLength="3" :key="showMoreKey">
        <div v-for="specialty in specialties" :key="specialty.id">
          <hp5-semantic size-selection="xs">
            <input :id="`specialty-${specialty.id}`" type="checkbox" v-model="filterContext.cc" :value="specialty.id" /><label
              :for="`specialty-${specialty.id}`"
              >{{ specialty.name }}</label
            >
          </hp5-semantic>
        </div>
      </FilterShowMore>
    </FilterExpandCollapse>
</template>
  
<script setup>

      const model = useFCPModel()
      const { filterContext, rawConcepts } = model
      const showMoreKey = computed(() => JSON.stringify(specialties.value))
      const type = computed(() => filterContext.value.type)
      const isTypeHospital = computed(() => type.value == 'hospital' || type.value == 'hospital:3' || type.value == 'hospital:2' || type.value == 'hospital:1' ? true : false)
      const show = computed(() => specialties.value && specialties.value.length > 0 && !isTypeHospital.value)

      const specialties = computed(() => {
        return rawConcepts.value.filter(concept => concept.type == 'specialty')
      })
  
</script>
  
<style scoped>
  label {
    padding-left: var(--spacing-xs);
  }
</style>